import { navigate as gatsbyNavigate } from 'gatsby';

let translateUrlFn = (url) => url; // default no-op translator

export const setTranslateUrlFn = (fn) => {
  if (typeof fn === 'function') {
    translateUrlFn = fn;
  } else {
    console.warn('setTranslateUrlFn: Expected a function but got:', typeof fn);
  }
};

export const navigate = (url, options) => {
  if (!url) {
    console.warn('navigate: URL is required');
    return null;
  }
  return gatsbyNavigate(translateUrlFn(url), options);
};

export default navigate;
